import { render, staticRenderFns } from "./KD3.vue?vue&type=template&id=2cf7dc7e"
import script from "./KD3.vue?vue&type=script&lang=js"
export * from "./KD3.vue?vue&type=script&lang=js"
import style0 from "./KD3.vue?vue&type=style&index=0&id=2cf7dc7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports